<template>
    <div id="servicespage">
        <spinner-text v-if="loading">
            {{ trans('pages.services.loading') }}
        </spinner-text>
        <template v-else>
            <div v-if="!orders || orders.length == 0">
                {{ trans('pages.services.no_orders') }}
            </div>
            <ui5-list v-else>
                <ui5-li
                    v-for="order in orders"
                    :key="'order.' + order.id"
                    @click="searchService(order.id)"
                    :description="
                        order.insertDate +
                        ' ' +
                        (order.waitForOrderConfirmation
                            ? ` (${trans(
                                  'pages.services.waiting_confirmation'
                              )})`
                            : '')
                    "
                >
                    {{ order.id }},
                    {{ order.customerName }}
                </ui5-li>
            </ui5-list>
        </template>
    </div>
</template>
<script>
import SpinnerText from '../components/loader/SpinnerText';
import orderApi from '../api/order';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    components: { SpinnerText },
    mixins: [localization],
    data() {
        return {
            loading: false,
            orders: null,
        };
    },
    methods: {
        searchService(orderId) {
            orderApi
                .validateServiceOrderExistance(orderId)
                .then(() => {
                    this.$router.push(
                        '/editproduct/?orderId=' +
                            orderId +
                            '&productState=show-producttype'
                    );
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.services.error_not_found')
                    );
                });
        },
        load() {
            this.loading = true;
            orderApi
                .fetchServicesForWinfakt()
                .then((response) => {
                    this.orders = response.data.data;
                })
                .catch(() => {
                    showErrorMessage(this.trans('pages.services.error_fetch'));
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    mounted() {
        this.load();
    },
};
</script>
